import { brand } from '../../../../theme/themePrimitives';
import CustomModal from '../../../modals';
import { RootState } from '../../../../redux/store';
import { useSelector } from 'react-redux';
import { Box, Button, Typography } from '@mui/material';

/**
 * @heading1: DeleteContactModal
 * @paragraph: A modal component to confirm the deletion of a contact.
 * Provides a warning message and actions to either cancel or confirm the deletion.
 * @param: {boolean} open - Determines whether the modal is open.
 * @param: {function} onClose - Function to handle closing the modal.
 */

const DeleteContactModal = ({ open, onClose, onConfirm }: { open: boolean; onClose: () => void, onConfirm: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders/selectedStage: An object containing the details from the Redux store.
     */
    const { selectedContact, loaders } = useSelector((state: RootState) => state.contact);

    return (
        <CustomModal open={open} handleClose={loaders.isDeleting ? () => null : onClose} isError={true} title="Confirmation">
            {/* Warning message with contact name & number */}
            <Typography variant="body1" align="center" mb={2}>
                Are you sure you want to delete this contact with name
                <Typography component="span" variant="body1" color={brand[300]}>
                    {` ${selectedContact?.contact_name} `}
                </Typography>
                and number
                <Typography component="span" variant="body1" color={brand[300]}>
                    {` ${selectedContact?.contact_number}`}
                </Typography>? This action cannot be undone.
            </Typography>
            {/* Action buttons */}
            <Box display="flex" gap={2} mt={2}>
                <Button variant="outlined" color="error" onClick={onClose} fullWidth disabled={loaders.isDeleting}>
                    Cancel
                </Button>
                <Button type="submit" variant="contained" color="error" onClick={onConfirm} fullWidth disabled={loaders.isDeleting}>
                    {loaders.isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            </Box>
        </CustomModal>
    );
};

export default DeleteContactModal;